import { render } from "./FpConsentButton.vue?vue&type=template&id=aca7abfc&scoped=true"
import script from "./FpConsentButton.vue?vue&type=script&lang=js"
export * from "./FpConsentButton.vue?vue&type=script&lang=js"

import "./FpConsentButton.vue?vue&type=style&index=0&id=aca7abfc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca7abfc"]])

export default __exports__